import React from "react";
import { ThumbnailsBlock } from '../ThumbnailsBlock';

export const ProductsBlock = ({ products, ...props }) => (
    <ThumbnailsBlock thumbnails={products} {...props} />
)